import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { TextField } from '@mui/material';
import { Container, Row, Col, NavItem } from 'react-bootstrap';
import './poQtyApproval.css';
import { textAlign } from '@mui/system';
import { PROD } from '../../../common/constants';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: { backgroundColor: "white", color: "#949494", fontWeight: "bold", fontSize: "2.3vh", textAlign: "center", },
    [`&.${tableCellClasses.body}`]: {
        fontFamily: "Roboto,sans-serif !important",
        textAlign: "center",
        fontSize: "2.3vh",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#D6EEEE',
    },
    '&:nth-of-type(even)': {
        backgroundColor: 'white',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ColorButton = styled(Button)(() => ({
    marginTop: 20,
    marginLeft: 30,
    width: 150,
    color: '#005BAA',
    backgroundColor: '#FFFFFF',
    '&:hover': {
        backgroundColor: '#005BAA',
        color: '#FFFFFF',
    },
    '&:active': {
        backgroundColor: '#FFFFFF',
        color: '#005BAA',
    }
}));


function createData(Sno, grower, ht, ll, tr, plant, is, cb, rb1, rb, totalcost) {
    return { Sno, grower, ht, ll, tr, plant, is, cb, rb1, rb, totalcost };
}

const rows = [
    createData(1, "G2", "HIT2", "LLE2", "TR3", "Plant", "LL2", "2276", "-", "3000", "10000000"),
    createData(2, "G5", "HIT3", "LLE1", "TR2", "Plant", "IS", "3456", "-", "5000", "400000"),
    createData(3, "G6", "HIT7", "LLE2", "TR1", "Plant", "LL2", "2345", "-", "14000", "6666660"),
    createData(4, "G7", "HIT8", "LLE1", "TR2", "Plant", "IS", "4567", "6000", "-", "9000000"),
    createData(5, "G8", "HIT9", "LLE2", "TR1", "Plant", "LL3", "5678", "9000", "-", "6000000"),
    createData(6, "G3", "HIT5", "LLE2", "TR2", "Plant", "IS", "4590", "8000", "-", "9000000"),
];

const approvalRows = [
    approverData("Tapas", "11-28-2022", "Version-1", "SIM-20221208-01", "Released", "View"),
    approverData("Tapas", "12-01-2022", "Interim Released", "SIM-20221208-02", "Sent to stakeholders for verification", "View"),
    approverData("Tapas", "12-02-2022", "Released", "SIM-20221208-03", "Due to flood in upper assam, loads diverted to lower assam", "View"),
    approverData("Bakul", "12-03-2022", "Sent Back", "SIM-20221208-01", "For district 1 roads have opened, please increase the load, please change the load for LLE5 to 20000", "View"),
    approverData("Tapas", "11-28-2022", "Released", "SIM-20221208-01", "LLE5 load not increased", "View"),
    approverData("Bakul", "12-05-2022", "Approved", "SIM-20221208-01", "Please discuss and check mizoram data", "View"),
    approverData("Chetan", "12-07-2022", "Approved", "SIM-20221208-01", "Mizoram data revised", "View"),
];

function approverData(approver, date, approvereject, planningNum, remarks, attachment) {
    return { approver, date, approvereject, planningNum, remarks, attachment };
}
function growerData(grower, qty) {
    return { grower, qty };
}

const growerRows = [growerData("G2", 3000), growerData("G5", 5000)];
const HitRows = [growerData("Hit2", 3000), growerData("Hit3", 5000)];
const LLERows = [growerData("LLE1", 4567), growerData("LLE2", 5678)];
const TrRows = [growerData("TR1", 2345), growerData("TR2", 4567)];

export default function PoQtyApproval() {
    const [month, setMonth] = React.useState(1);
    const navigate = useNavigate();

    const handleChange = (event) => {
        setMonth(event.target.value);
    };

    return (
        <>

            <Container fluid>

                <Row>


                    {/* <Col xs={12} md={3} className='common-internal-sidebar-col'>
                        <div className="common-internal-sidebar-container">
                            <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate('/DashboardStakeHolder'))} />
                        </div>
                    </Col> */}
                    <Col xs={12} md={12}>
                    {!PROD &&  <p style={{textAlign:"center", fontSize:"2vh"}}>PIT22</p>}
                        <Row>
                        <Col xs={12} md={12} sm={12}>
                            <h3 className="headingStylePIT">PO Quantity Approval </h3>
                         </Col>   
                            <Col xs={12} md={4} sm={4}>

                                <div>
                                    <p style={{ marginLeft:"13px",marginBottom: "0rem"}}>Planning Year</p>
                                    <FormControl fullWidth >
                                        {/* <InputLabel id="demo-simple-select-label" >Planning Month</InputLabel> */}

                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={1}
                                            style={{ height: "5vh", width: "20vh" }}
                                            disabled
                                        >
                                            <MenuItem selected value={1}>2022-23</MenuItem>

                                        </Select>

                                    </FormControl>
                                </div>
                            </Col>
                            <Col xs={12} md={4} sm={4}>
                                <div style={{  }}>
                                    <p style={{ marginLeft:"13px",marginBottom: "0rem"}}>Planning Month</p>
                                    <FormControl fullWidth >
                                        {/* <InputLabel id="demo-simple-select-label" >Planning Month</InputLabel> */}

                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={month}
                                            style={{ height: "5vh", width: "20vh" }}
                                            disabled
                                        >
                                            <MenuItem selected value={1}>January</MenuItem>
                                            <MenuItem value={2}>Feburary</MenuItem>
                                            <MenuItem value={3}>March</MenuItem>
                                            <MenuItem value={4}>April</MenuItem>
                                            <MenuItem value={5}>May</MenuItem>
                                            <MenuItem value={6}>June</MenuItem>
                                            <MenuItem value={7}>July</MenuItem>
                                            <MenuItem value={8}>August</MenuItem>
                                            <MenuItem value={9}>September</MenuItem>
                                            <MenuItem value={10}>October</MenuItem>
                                            <MenuItem value={11}>November</MenuItem>
                                            <MenuItem value={12}>December</MenuItem>
                                        </Select>

                                    </FormControl>

                                </div >
                            </Col>
                            <Col xs={12} sm={4} md={4}>
                                <div>
                                        <p style={{marginLeft:"26px",marginBottom: "0rem" }}>Planning Number/ID</p>
                                        <FormControl style={{ margin: "0px !important" }} fullWidth>

                                            <TextField   disabled value={"SIM-20221208-01"} id="plannerOutput" type="text" />
                                        </FormControl>
 
                                </div>
                            </Col>
                        </Row>
                        {/* </Grid>
                        </Grid> */}
                        <h3 className="loading-completion-text"> All Route Allocation </h3>
                        <TableContainer >
                            <Table sx={{
                                minWidth: 800, borderSpacing: "2px", width: "100%",
                                border: "grey 1px Solid", borderRadius: "1vh"
                            }} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell textAlign="center" >SNO</StyledTableCell>
                                        <StyledTableCell textAlign="center" >Grower</StyledTableCell>
                                        <StyledTableCell textAlign="center" >HIT</StyledTableCell>
                                        <StyledTableCell textAlign="center" >LLE</StyledTableCell>
                                        <StyledTableCell textAlign="center" >TR</StyledTableCell>
                                        <StyledTableCell textAlign="center">PLANT</StyledTableCell>
                                        <StyledTableCell textAlign="center">IS</StyledTableCell>
                                        <StyledTableCell textAlign="center">CB Qty</StyledTableCell>
                                        <StyledTableCell textAlign="center">RB QTY(final with moisture)</StyledTableCell>
                                        <StyledTableCell textAlign="center">RB QTY(final without moisture)</StyledTableCell>
                                        <StyledTableCell textAlign="center">Total Cost</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <StyledTableRow key={row.name}>
                                            <StyledTableCell textAlign="center" >{row.Sno}</StyledTableCell>
                                            <StyledTableCell textAlign="center" >{row.grower}</StyledTableCell>
                                            <StyledTableCell textAlign="center" >{row.ht}</StyledTableCell>
                                            <StyledTableCell textAlign="center" >{row.ll}</StyledTableCell>
                                            <StyledTableCell textAlign="center" >{row.tr}</StyledTableCell>
                                            <StyledTableCell textAlign="center" >{row.plant}</StyledTableCell>
                                            <StyledTableCell textAlign="center" >{row.is}</StyledTableCell>
                                            <StyledTableCell textAlign="center" >{row.cb}</StyledTableCell>
                                            <StyledTableCell textAlign="center" >{row.rb1}</StyledTableCell>
                                            <StyledTableCell textAlign="center" >{row.rb}</StyledTableCell>
                                            <StyledTableCell textAlign="center" >{row.totalcost}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br></br>
                        <h3 className="loading-completion-text"> Stakeholder Allocation </h3>
                        <Grid container spacing={2} style={{ marginLeft: "0px" }}>
                            <Grid item xs={12} sm={6} md={3}>
                                <TableContainer >
                                    <Table
                                        sx={{ minWidth: 100, width: '80%', border: "grey 1px Solid", borderRadius: "1vh" }}
                                        aria-label="customized table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="right">Grower</StyledTableCell>
                                                <StyledTableCell align="right">QTY</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {growerRows.map((row) => (
                                                <StyledTableRow key={row.name}>
                                                    <StyledTableCell align="right">
                                                        {row.grower}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right">{row.qty}</StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TableContainer >
                                    <Table
                                        sx={{ minWidth: 100, width: '80%', border: "grey 1px Solid", margin: "1vh", borderRadius: "1vh" }}
                                        aria-label="customized table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="right">HIT</StyledTableCell>
                                                <StyledTableCell align="right">QTY</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {HitRows.map((row) => (
                                                <StyledTableRow key={row.name}>
                                                    <StyledTableCell align="right">
                                                        {row.grower}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right">{row.qty}</StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TableContainer >
                                    <Table
                                        sx={{ minWidth: 100, width: '80%', border: "grey 1px Solid", margin: "1vh", borderRadius: "1vh" }}
                                        aria-label="customized table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="right">LLE</StyledTableCell>
                                                <StyledTableCell align="right">QTY</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {LLERows.map((row) => (
                                                <StyledTableRow key={row.name}>
                                                    <StyledTableCell align="right">
                                                        {row.grower}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right">{row.qty}</StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TableContainer >
                                    <Table
                                        sx={{ minWidth: 100, width: '80%', border: "grey 1px Solid", margin: "1vh", borderRadius: "1vh" }}
                                        aria-label="customized table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="right">Transporter</StyledTableCell>
                                                <StyledTableCell align="right">QTY</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {TrRows.map((row) => (
                                                <StyledTableRow key={row.name}>
                                                    <StyledTableCell align="right">
                                                        {row.grower}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right">{row.qty}</StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                        <button className="buttonStyleDownload" type="button" value="Submit">Download</button>
                        <br /><br />
                       
                        <Row>
                            <Col xs={12} sm={12} md={12}>
                                <div style={{ marginBottom: "10px", display: "inline-flex" }}>
                                    <button className="buttonStyle" type="button" value="Submit">Run in Simulation</button>
                                    <button className="buttonStyle" type="button" value="Submit">Edit</button>
                                    <button className="buttonStyle" type="button" value="Submit">Release</button>
                                    <button className="buttonStyle" type="button" value="Submit">Send Back</button>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={6} md={6}>
                                <div style={{ margin: "10px", display: "-webkit-box" }}>
                                    <p style={{ marginRight: "10px", marginTop: "8px" }}>Comments</p>
                                    <FormControl style={{ margin: "0px !important" }} fullWidth>

                                        <TextField
                                            aria-label="empty textarea"
                                            placeholder=""
                                            style={{ width: 300, height: 50 }}
                                        ></TextField>
                                    </FormControl>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6}>
                                <button className="buttonStyleUpload" type="button" value="Submit">Upload</button>
                            </Col>
                        </Row>








                        <h3 className="loading-completion-text">Approval History</h3>

                        <TableContainer>
                            <Table
                                sx={{
                                    minWidth: 800, borderSpacing: "2px", width: "100%",
                                    border: "grey 1px Solid", borderRadius: "1vh"
                                }}
                                aria-label="customized table"
                            >
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell textAlign="center"  >Approver</StyledTableCell>
                                        <StyledTableCell textAlign="center" >Approval Date</StyledTableCell>
                                        <StyledTableCell textAlign="center"  >Approve/Reject</StyledTableCell>
                                        <StyledTableCell textAlign="center"  >Planning Number</StyledTableCell>
                                        <StyledTableCell textAlign="center" >Remarks</StyledTableCell>
                                        <StyledTableCell textAlign="center" >Attachment</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {approvalRows.map((row) => (
                                        <StyledTableRow key={row.name}>
                                            <StyledTableCell textAlign="center" >
                                                {row.approver}
                                            </StyledTableCell>
                                            <StyledTableCell textAlign="center"  >{row.date}</StyledTableCell>
                                            <StyledTableCell textAlign="center"  >
                                                {row.approvereject}
                                            </StyledTableCell>
                                            <StyledTableCell textAlign="center"  >
                                                {row.planningNum}
                                            </StyledTableCell>
                                            <StyledTableCell textAlign="center"  >
                                                {row.remarks}
                                            </StyledTableCell>
                                            <StyledTableCell textAlign="center"  >
                                                <a href="#">{row.attachment}</a>
                                            </StyledTableCell>

                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
